import { motion } from "framer-motion";
import React from "react";
import { Arrow } from "./Icons/Arrow";
import { ImageComp } from "./ImageComp";
import { Pallette } from "./Pallette";
import { ShowImg } from "./ShowImg";

function ShowDcomp({ state, setState, nonMutable }) {
  return (
    <>
      <motion.div
        className="animate--wrapper"
        layoutId={state.layoutId}
        transition={{ duration: 0.5 }}
      >
        <motion.div className="show--wrapper">
          <motion.div
            className="show--top"
            layoutId={`show--top--${state.layoutId}`}
            onTap={() => {
              setState({ ...nonMutable });
            }}
          >
            <ImageComp image={state.thumb} alt={`${state.thumb}--thumbnail`} />
          </motion.div>
          <motion.div
            className="show--mid"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            layoutId={`show--mid--${state.layoutId}`}
          >
            <motion.div className="mid--top">
              <motion.h3>{state.title}</motion.h3>
              <motion.p>{state.body.body}</motion.p>
            </motion.div>
            <motion.div className="mid--bottom">
              <motion.h4>Color Pallette</motion.h4>
              <Pallette pal={state.pal} />
            </motion.div>
          </motion.div>
          <motion.div
            className="show--bottom"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            layoutId={`show--bottom--${state.layoutId}`}
          >
            <ShowImg imgs={state.images} title={state.title} />
          </motion.div>
          <motion.div
            className="close"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            layoutId={`close--${state.layoutId}`}
          >
            <button
              onClick={() => {
                setState({ ...nonMutable });
              }}
            >
              <Arrow />
              Back to Designs
            </button>
          </motion.div>
        </motion.div>
      </motion.div>
    </>
  );
}

export { ShowDcomp };
